// extracted by mini-css-extract-plugin
export default {"welcomeWrapper":"welcomeNote_welcomeWrapper__fYm1M","childWrp":"welcomeNote_childWrp__CIiLL"};